import { useState, useRef, useEffect } from "react";
import CreditNotesUi from "./CreditNotesUi";
import { changeDateFormatForServer } from "../../Utils/dateUtils";
import * as toast from "../../Wrapper/toast/toast";
import * as apiHelper from "../../Services/ApiHelper";
import { useNavigate } from "react-router-dom";
import { getCreditStatus } from "../../Services/common";

const CreditNotes = () => {
  const initialCreditNoteData = {
    cn_amount: "",
    cn_number: "",
    cn_date: "",
    remark: "",
    status: "",
    settled_bill_no: "",
    settled_remark: "",
    product_id: "",
    product_detail_id: "",
  };

  let navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [creditNotesList, setCreditNotesList] = useState([]);
  const [lastSelectedPage, setLastSelectedPage] = useState(1);
  const [dates, setDates] = useState({ startDate: null, endDate: null });

  const [modalShow, setModalShow] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [creditNoteData, setCreditNoteData] = useState(initialCreditNoteData);
  const [statusFilter, setStatusFilter] = useState(["OPEN"]);
  const statusOptions = getCreditStatus();

  const datePickerStartRef = useRef();
  const datePickerEndRef = useRef();

  useEffect(() => {
    if (
      (dates.startDate !== null && dates.endDate !== null) ||
      (dates.startDate === null && dates.endDate === null)
    ) {
      getCreditNotesList(lastSelectedPage);
    }
  }, [dates]);

  const onPageChange = (page) => {
    getCreditNotesList(page);
  };
  const openDetailsPage = (id) => {
    navigate("/purchase-medicines", { state: { id } });
  };
  const handleStatusFilterChange = (options) => {
    setStatusFilter(options);
  };
  useEffect(() => {
    getCreditNotesList(lastSelectedPage);
  }, [statusFilter]);

  const getCreditNotesList = (page = 1) => {
    const query = {
      page: page,
      limit: 10,
      start_date: changeDateFormatForServer(dates.startDate),
      end_date: changeDateFormatForServer(dates.endDate),
      q: searchQuery,
      filter: statusFilter,
    };

    setLastSelectedPage(page);
    setLoading(true);

    apiHelper.getCreditNoteList(query).then((response) => {
      if (response?.isSuccess) {
        setCreditNotesList(response.data);
      } else {
        toast.warn(response?.message);
      }
      setLoading(false);
    });
  };

  const handleClose = () => {
    setModalShow(false);
    setCreditNoteData(initialCreditNoteData);
  };

  const handleEdit = (data) => {
    setCreditNoteData({
      product_id: data?.product?.id,
      product_detail_id: data?.product_detail?.id,
      id: data.id,
      cn_amount: parseFloat(data.cn_amount),
      cn_number: data.cn_number,
      cn_date: new Date(data.cn_date),
      status: data?.status,
      remark: data.remark || "",
      settled_bill_no: data.settled_bill_no,
      settled_remark: data.settled_remark,
    });
    setModalShow(true);
  };

  const handleSave = () => {
    setButtonLoading(true);
    const {
      cn_amount,
      product_id,
      product_detail_id,
      cn_number,
      cn_date,
      remark,
      id,
      settled_bill_no,
      settled_remark,
      status,
      bill_no,
      quantity,
    } = creditNoteData;

    const payload = {
      id: id,
      quantity,

      bill_no,
      product_id,
      product_detail_id,
      cn_amount,
      cn_number,
      cn_date: changeDateFormatForServer(cn_date),
      remark,
      status: status, // Always send as SETTLED when editing
      settled_bill_no: settled_bill_no, // fallback empty if not present
      settled_remark: settled_remark,
    };

    apiHelper
      .editCreditNote(payload)
      .then((response) => {
        if (response?.isSuccess) {
          toast.success(response.message);
          getCreditNotesList(lastSelectedPage);
          handleClose();
        } else {
          toast.warn(response?.message);
        }
      })
      .catch((error) => {
        toast.warn(error.message);
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  return (
    <CreditNotesUi
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      dates={dates}
      setDates={setDates}
      datePickerStartRef={datePickerStartRef}
      datePickerEndRef={datePickerEndRef}
      loading={loading}
      onPageChange={onPageChange}
      getCreditNotesList={getCreditNotesList}
      creditNotesList={creditNotesList}
      modalShow={modalShow}
      setModalShow={setModalShow}
      creditNoteData={creditNoteData}
      setCreditNoteData={setCreditNoteData}
      handleClose={handleClose}
      handleSave={handleSave}
      buttonLoading={buttonLoading}
      handleEdit={handleEdit}
      openDetailsPage={openDetailsPage}
      statusOptions={statusOptions}
      statusFilter={statusFilter}
      handleStatusFilterChange={handleStatusFilterChange}
    />
  );
};

export default CreditNotes;
